<template>
	<div>
		<h1>
			Create a news item
		</h1>

		<form class="mt-4" @submit.prevent="createNews">
			<div class="form-group">
				<label for="title">
					<small class="text-muted">TITLE</small>
				</label>
				<input type="text" class="form-control" name="title" placeholder="Title" v-model="title" required autofocus>
			</div>

			<div class="form-group">
				<label>
					<small class="text-muted">CONTENT</small>
				</label>
				<quill-editor v-model="content" :options="quillOptions" />
			</div>

			<div class="form-group">
				<label for="content">
					<small class="text-muted">IMAGE</small>
				</label>
				<file-input @change="setImage" placeholder="Choose an image" required />
			</div>

			<div class="form-group">
				<label for="content">
					<small class="text-muted">IMAGES</small>
				</label>
				<file-input @change="files => images = files" multiple placeholder="Choose images" />
			</div>

			<button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading" :class="{running: loading}">
				{{ loading ? 'Creating…' : 'Create' }}
				<div class="ld ld-ring ld-spin" />
			</button>
		</form>

		<div class="alert alert-danger mt-4" v-if="!loading && error">
			<p class="mb-0 text-center">
				{{ error }}
			</p>
		</div>
	</div>
</template>

<script>
	import {getError} from '../../../helpers';
	import FileInput from '../../FileInput';

	export default {
		components: {
			'file-input': FileInput,
		},

		data() {
			return {
				title: '',
				content: '',
				image: null,
				images: [],

				quillOptions: {
					placeholder: 'Insert a description...',
				},
				
				loading: false,
				error: '',
			};
		},
		
		methods: {
			createNews() {
				this.loading = true;

				this.$store.dispatch('news/create', {
					title: this.title,
					content: this.content,
					image: this.image,
					images: this.images
				}).then(news => {
					this.$router.push({name: 'view-news', params: {
						id: news.id,
					}});
				}).catch(e => {
					this.error = getError(e);
					this.loading = false;
				});
			},

			setImage(files) {
				this.image = files[0];
			}
		},

		meta: {
			title: 'Create a news item',

			meta: [
				{property: 'og:title', content: 'Create a news item / Al-Shayah'},
			],
		},
	};
</script>
